import { Dialog, ThemeProvider } from "@gravity-ui/uikit";
import { reatomContext } from "@reatom/npm-react";
import { ReactNode, useEffect, useRef, useState, FC } from "react";
import { createRoot } from "react-dom/client";
import { ctx } from "src/index";

enum AlertType {
  ALERT,
  CONFIRM,
}

export interface IAlertProps {
  message: ReactNode;
  title: ReactNode;
  type: AlertType;
}

const rootID = "alert-div";

let returnResponse: (value: boolean) => void;

const AlertRoot: FC<IAlertProps> = ({ message, title, type }) => {
  const [open, setOpen] = useState(true);

  const localStorageThemeValue = localStorage.getItem("theme");
  const theme = localStorageThemeValue
    ? JSON.parse(localStorageThemeValue)?.data || "system"
    : "system";

  const root = useRef<HTMLDivElement | null>();

  useEffect(() => {
    root.current = document.getElementById(rootID) as HTMLDivElement;
  }, []);

  function Close() {
    root.current?.remove();
    setOpen(false);
  }

  function Confirm() {
    if (type === AlertType.CONFIRM) {
      returnResponse(true);
    }
    Close();
  }

  function Cancel() {
    if (type === AlertType.CONFIRM) {
      returnResponse(false);
    }
    Close();
  }

  return (
    <reatomContext.Provider value={ctx}>
      <ThemeProvider theme={theme}>
        <Dialog onClose={Cancel} open={open} disableOutsideClick={true}>
          <Dialog.Header caption={title} />
          <Dialog.Body>{message}</Dialog.Body>
          <Dialog.Footer
            onClickButtonCancel={Cancel}
            onClickButtonApply={Confirm}
            textButtonApply="Ок"
            textButtonCancel={type === AlertType.CONFIRM ? "Отмена" : undefined}
          />
        </Dialog>
      </ThemeProvider>
    </reatomContext.Provider>
  );
};

function Create(
  message: ReactNode,
  title: ReactNode,
  type: AlertType = AlertType.ALERT,
) {
  let div = document.getElementById(rootID);
  if (!div) {
    div = document.createElement("div");
    div.id = rootID;
    document.body.appendChild(div);
  }

  const root = createRoot(div);
  root.render(<AlertRoot message={message} title={title} type={type} />);
}

export function ShowConfirmDialog(
  message: ReactNode,
  title: ReactNode = "Confirm",
) {
  Create(message, title, AlertType.CONFIRM);

  return new Promise<boolean>((resolve) => {
    returnResponse = resolve;
  });
}

export function ShowAlertDialog(
  message: ReactNode,
  title: ReactNode = "Alert",
) {
  Create(message, title, AlertType.ALERT);
}
